import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import BackCircle from "../components/Buttons/BackCircle";
import SimpleButton from "../components/Buttons/SimpleButton";
import HalfColumn from "../components/Column/HalfColumn";
import { NavBar } from "../components/NavBar";
import Row from "../components/Row/Row";
import Text from "../components/Text/Text";
import back_circle from "../imgs/back_circle.svg";
import create_nft_bg from "./imgs/create_nft_bg.png";

interface CreateNFTProps {
  theme: string;
  toggleTheme: () => void;
}

const CreateNFTContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: url(${create_nft_bg}) no-repeat center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export const CreateNFTPage: React.FC<CreateNFTProps> = ({
  theme,
  toggleTheme,
}) => {
  const navigate = useNavigate();

  const onLearnMoreClick = () => {
    navigate('/howitworks')
  }

  const onStartClick = () => {
    navigate('/choose_nft_option')
    }
  return (
    <>
      <NavBar theme={theme} themeToggler={toggleTheme} />

      <CreateNFTContainer>
        <HalfColumn
          style={{
            textAlign: "center",
            marginTop: "5%",
            minHeight: "70vh",
            justifyContent: "space-evenly",
          }}
        >
          <div style={{position: 'relative'}}>

            <Text bold={true} size={"40px"}>
              Create Your NFT
            </Text>
          </div>

          <Text size={'18px'} style={{paddingInline: '10%'}}>
          Welcome to the world music NFTs! In a few short clicks, your music will be tokenized and available for 
          millions of fans worldwide to purchase as a Non-Fungible Token.
          </Text>

          <Row style={{ width: "100%" }} align={"space-evenly"}>
            <SimpleButton secondary onClick={onLearnMoreClick}>Learn More</SimpleButton>

            <SimpleButton onClick={onStartClick} style={{paddingInline: '3.5%'}}>Start</SimpleButton>
          </Row>
        </HalfColumn>
      </CreateNFTContainer>
    </>
  );
};
